import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTypedParams } from '@repo/routes';
import { Sidebar, SidebarContent, SidebarHeader } from '@repo/ui-primitives/sidebar';
import { Skeleton } from '@repo/ui-primitives/skeleton';
import { cn } from '@repo/ui-primitives/utils';
import { useCurrentUserOrganizationList } from '@repo/user-context';
import { useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { ProjectsList, useExpandedProjects } from './sidebar';
export function AppSidebar(param) {
    let { className } = param;
    const { organizationList, isLoading: orgsLoading } = useCurrentUserOrganizationList();
    const navigate = useNavigate();
    const { organization } = useTypedParams();
    const { expandedProjects, toggleProject, expandProject, expandAll, collapseAll } = useExpandedProjects(organization !== null && organization !== void 0 ? organization : '');
    useEffect(()=>{
        const handleKeyDown = (event)=>{
            const activeElement = document.activeElement;
            const isInputFocused = activeElement && (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA' || activeElement.tagName === 'SELECT' || activeElement.getAttribute('contenteditable') === 'true');
            if (!isInputFocused && organizationList && organizationList.length > 1) {
                const currentOrgIndex = organizationList.findIndex((org)=>org.name === organization);
                if (event.key === 'j') {
                    event.preventDefault();
                    const nextIndex = (currentOrgIndex + 1) % organizationList.length;
                    const targetOrg = organizationList[nextIndex];
                    if (!targetOrg) return;
                    navigate({
                        to: "/org/".concat(targetOrg.name)
                    }).catch((error)=>{
                        if (error instanceof Error) {
                            throw new Error("Navigation error: ".concat(error.message));
                        } else {
                            throw new Error('Unknown navigation error');
                        }
                    });
                } else if (event.key === 'k') {
                    event.preventDefault();
                    const prevIndex = currentOrgIndex === 0 ? organizationList.length - 1 : currentOrgIndex - 1;
                    const targetOrg = organizationList[prevIndex];
                    if (!targetOrg) return;
                    navigate({
                        to: "/org/".concat(targetOrg.name)
                    }).catch((error)=>{
                        if (error instanceof Error) {
                            throw new Error("Navigation error: ".concat(error.message));
                        } else {
                            throw new Error('Unknown navigation error');
                        }
                    });
                }
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        organization,
        organizationList,
        navigate
    ]);
    if (orgsLoading || !organizationList) {
        return /*#__PURE__*/ _jsxs(Sidebar, {
            collapsible: "offcanvas",
            className: cn(className),
            children: [
                /*#__PURE__*/ _jsx(SidebarHeader, {
                    children: /*#__PURE__*/ _jsx(Skeleton, {
                        className: "h-16 w-full"
                    })
                }),
                /*#__PURE__*/ _jsxs(SidebarContent, {
                    children: [
                        /*#__PURE__*/ _jsx(Skeleton, {
                            className: "h-6 w-full"
                        }),
                        /*#__PURE__*/ _jsx(Skeleton, {
                            className: "h-6 w-full"
                        }),
                        /*#__PURE__*/ _jsx(Skeleton, {
                            className: "h-6 w-full"
                        })
                    ]
                })
            ]
        });
    }
    if (!organization) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Sidebar, {
        className: cn(className),
        children: /*#__PURE__*/ _jsx(SidebarContent, {
            children: /*#__PURE__*/ _jsx(ProjectsList, {
                organization: organization,
                expandedProjects: expandedProjects,
                onToggleProject: toggleProject,
                onExpandProject: expandProject,
                onExpandAll: expandAll,
                onCollapseAll: collapseAll
            })
        })
    });
}
